<template>
    <div>
        <div class="d-flex flex-column vh-100">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AuthLayout',
        props: {
            from: {
                type: String,
                default: null
            }
        },
        created() {
            this.$store.dispatch('auth/initAuthPage', {from: this.from});
        }
    }
</script>
